import React, { useEffect } from 'react';
import axios from 'axios';
import { api } from 'utils/service';
import { getAuthTokens } from 'utils/cookies';

interface AxiosInterceptorsTokenProps {}

export const AxiosInterceptorsToken: React.FC<AxiosInterceptorsTokenProps> = ({ children }) => {
  useEffect(() => {
    const ids = [api, axios].map((instance) => {
      const id = instance.interceptors.request.use((config) => {
        const { token } = getAuthTokens();
        if (token) {
          config.headers['Authorization'] = 'Bearer ' + token;
        }
        return config;
      });
      return { id, instance };
    });

    return () => {
      ids.forEach(({ instance, id }) => {
        instance.interceptors.request.eject(id);
      });
    };
  }, []);

  return <>{children}</>;
};
